import { createActionLayout } from '@malesia/react-components/dist/src/components/Table/columns/actionsColumn/actionLayout';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const editFlightCompany = createActionLayout({
    text: (
        <FormattedMessage
            id='front-app/FlightCompanyListPage:editTitle'
            defaultMessage='Edit airline company'
        />
    ),
    iconName: 'edit',
});
